"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditsReplenishedDialog = CreditsReplenishedDialog;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_intl_1 = require("react-intl");
const actions_1 = __importDefault(require("@src/actions"));
function CreditsReplenishedDialog() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useHistory)();
    const intl = (0, react_intl_1.useIntl)();
    // @ts-ignore
    const isOpenCreditsReplenishedDialog = (0, react_redux_1.useSelector)(state => state.admin.isOpenCreditsReplenishedDialog);
    const goToUpsell = () => {
        history.pushLocalized('/admin/pridat-ponuku');
        dispatch(actions_1.default.adminToggleCreditsReplenishedDialog(false));
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, { onCancel: () => dispatch(actions_1.default.adminToggleCreditsReplenishedDialog(false)), onOk: goToUpsell, okText: intl.formatMessage({ id: 'admin.offers.add_offer' }), visible: isOpenCreditsReplenishedDialog, title: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.notification.payment_success_dialog.start_advertise" }), children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col justify-center align-center p-l", children: [(0, jsx_runtime_1.jsx)("div", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)("img", { style: { width: '160px' }, src: "/media/illustrations/streamline-icon-circle-coin-sparkle.svg", alt: "" }) }), (0, jsx_runtime_1.jsx)("div", { className: "font-size-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "global.notification.payment_success_dialog.credits_replenished" }) })] }) }));
}
